export const getAvgOrCountOfEvents = (
  data,
  key,
  sumOrAverage,
  behaviourChosen
) => {
  const doesNotHaveData =
    data?.length === 0 ||
    !data ||
    data?.filter((i) => i?.[key] !== null).length === 0;

  if (doesNotHaveData) {
    return undefined;
  }

  const valuesArr = [...data]
    .map((i) => i?.[key])
    ?.filter((value) => value !== null);

  const count = [...valuesArr].reduce(
    (firstVal, secondVal) => firstVal + secondVal,
    0
  );
  const avg = count / valuesArr.length;
  const result = sumOrAverage === "count" ? count : avg;

  // For independence, return time in the form of hours
  if (behaviourChosen === "independence") {
    const totalTime = (result / 60).toFixed(1);
    if (totalTime.split(".")[1] === "0") {
      return totalTime.split(".")[0]; // i.e. show 1 if 1.0
    } else {
      return totalTime;
    }
  }
  return Math.round(result);
};
